import { FC } from 'react';
import Button from './Button';
import { RefactoredButtonProps } from './button-props';

const BackButton: FC<RefactoredButtonProps> = ({ title, onClick, enabled = true }: RefactoredButtonProps) => {
  return (
    <Button disabled={!enabled} size="xs" textColor="black" color="body" onClick={(e) => onClick && onClick(e)}>
      {title}
    </Button>
  );
};

export default BackButton;
